/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Typescript_Faq_A3Inputs */

const en_to_typescript_faq_a3 = /** @type {(inputs: To_Typescript_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Each nested object gets its own interface, and the parent interface references it by name. Deeply nested structures are fully supported.`)
};

const ko_to_typescript_faq_a3 = /** @type {(inputs: To_Typescript_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`네. 각 중첩 객체는 자체 인터페이스를 생성하고, 부모 인터페이스가 이름으로 참조합니다. 깊이 중첩된 구조도 완벽하게 지원됩니다.`)
};

const ja_to_typescript_faq_a3 = /** @type {(inputs: To_Typescript_Faq_A3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。各ネストされたオブジェクトに独自のインターフェースが生成され、親インターフェースが名前で参照します。深くネストされた構造も完全にサポートされています。`)
};

/**
* | output |
* | --- |
* | "Yes. Each nested object gets its own interface, and the parent interface references it by name. Deeply nested structures are fully supported." |
*
* @param {To_Typescript_Faq_A3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_typescript_faq_a3 = /** @type {((inputs?: To_Typescript_Faq_A3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Typescript_Faq_A3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_typescript_faq_a3(inputs)
	if (locale === "ko") return ko_to_typescript_faq_a3(inputs)
	return ja_to_typescript_faq_a3(inputs)
});